export default __webpack_public_path__ + "static/media/step_3_do.7fb0ed5b.jpg";